export default {
  box: {
    textAlign: 'center',
    padding: 0,
    margin: 0,
    display: 'block',
    cursor: 'pointer'
  }
};



// WEBPACK FOOTER //
// ./src/common/ShowArrow/style.js